export const IRONROOT_PRICING = [
  {
    tier: "starter",
    name: "Starter",
    price: 49,
    foundingPrice: 29.4,
    monthlyLabel: "$49/month",
    foundingMonthlyLabel: "$29.40/month",
  },
  {
    tier: "professional",
    name: "Professional",
    price: 99,
    foundingPrice: 59.4,
    monthlyLabel: "$99/month",
    foundingMonthlyLabel: "$59.40/month",
  },
  {
    tier: "business",
    name: "Business",
    price: 199,
    foundingPrice: 119.4,
    monthlyLabel: "$199/month",
    foundingMonthlyLabel: "$119.40/month",
  },
];

export const IRONROOT_PRICING_BY_TIER = Object.fromEntries(
  IRONROOT_PRICING.map((plan) => [plan.tier, plan]),
);

export const FOUNDING_PRICING_LINE = "Starter $29.40/mo · Professional $59.40/mo · Business $119.40/mo";
export const STANDARD_PRICING_LINE = "Starter $49/mo · Professional $99/mo · Business $199/mo";